// extracted by mini-css-extract-plugin
export var button = "DefaultButton-module--button--2hhen";
export var radioInput = "DefaultButton-module--radioInput--2BF5w";
export var primary = "DefaultButton-module--primary--2FZ07";
export var secondary = "DefaultButton-module--secondary--19Znm";
export var ghost = "DefaultButton-module--ghost--22YsA";
export var light = "DefaultButton-module--light--2sWdZ";